import gql from "graphql-tag";

const contractMutations = {


    createContract: gql`
        mutation CreateContract($indexed: Boolean, $defective: Boolean, $defective_message: String, $date_of_contract: DateTime, $warranty_period_start: DateTime, $warranty_period_end: DateTime, $created_at: DateTime, $updated_at: DateTime, $deleted_at: DateTime, $building_id: Int, $contact_id: Int, $user_id: Int) {
            createContract(indexed: $indexed, defective: $defective, defective_message: $defective_message, date_of_contract: $date_of_contract, warranty_period_start: $warranty_period_start, warranty_period_end: $warranty_period_end, created_at: $created_at, updated_at: $updated_at, deleted_at: $deleted_at, building_id: $building_id, contact_id: $contact_id, user_id: $user_id) {
                id,
                indexed,
                defective,
                defective_message,
                date_of_contract,
                warranty_period_start,
                warranty_period_end,
                created_at,
                updated_at,
                deleted_at,
                building_id,
                contact_id,
                user_id
            }
        }
    `,
    updateContract: gql`
        mutation UpdateContract($id: ID!, $indexed: Boolean, $defective: Boolean, $defective_message: String, $date_of_contract: DateTime, $warranty_period_start: DateTime, $warranty_period_end: DateTime, $created_at: DateTime, $updated_at: DateTime, $deleted_at: DateTime, $building_id: Int, $contact_id: Int, $user_id: Int) {
            updateContract(id: $id, indexed: $indexed, defective: $defective, defective_message: $defective_message, date_of_contract: $date_of_contract, warranty_period_start: $warranty_period_start, warranty_period_end: $warranty_period_end, created_at: $created_at, updated_at: $updated_at, deleted_at: $deleted_at, building_id: $building_id, contact_id: $contact_id, user_id: $user_id) {
                id,
                indexed,
                defective,
                defective_message,
                date_of_contract,
                warranty_period_start,
                warranty_period_end,
                created_at,
                updated_at,
                deleted_at,
                building_id,
                contact_id,
                user_id
            }
        }
    `,
};

export default contractMutations;